import React, { useState, useEffect } from 'react'
import { Mutation } from 'react-apollo'
import _ from 'lodash'
import { Link } from 'react-router-dom'
import { useMutation } from '@apollo/react-hooks'
import moment from 'moment'
import {
  message, Select, Icon, Menu, Dropdown, Button, Select as AntdSelect, Modal, DatePicker, Upload, Radio,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton, Input, H4,
} from 'konsys-ui'
import numeral from 'numeral'
import { UPDATE_BILL, DELETE_BILL } from '../../constants/graphql/mutation'
import { BILL_INFO } from '../../constants/graphql/query'
import history from '../../history'
import { theme } from '../../styles/_variables'
import { status, statusText, bankList } from '../../pages/bill-page/constants'
import { P } from '../../pages/bill-page/styled'
import {
  MethodButton, EachInput, DatePicker as DP, TaxSelect,
} from './styled'
import PERMISSION from '../../constants/permissions'
import { checkFloat } from '../../utils/util-services'
import { getAccessToken, getURL } from '../../utils/local-data-service'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange, value }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)} value={value}/>
)

export const DropdownSelector = ({
  data, handleChange, typeNameTh,
}) => {
  const width = typeNameTh ? '120px' : '100px'
  return (
    <AntdSelect
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
    >
    {
      data.map(v => <AntdSelect.Option key={v.value} value={v.value}>{v.text}</AntdSelect.Option>)
    }
    </AntdSelect>
  )
}

export const StatusSelector = ({
  handleChange, filter, disabled,
}) => {
  const arr = [
    { value: status.WAITING, text: statusText.WAITING },
    { value: status.OVERDUE, text: statusText.OVERDUE },
    { value: status.PAID, text: statusText.PAID },
    { value: status.CANCELLED, text: statusText.CANCELLED },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      style={{ width: 130 }}
      defaultValue="ทั้งหมด"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

const menu = (original, refetch) => {
  const [doCancel] = useMutation(DELETE_BILL)
  return (
  <Div>
    <Menu selectedKeys={[null]}>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_BILL)}>
        <Link target="_blank" to={`/bill/view/${original.id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item key='edit' disabled={!_.includes(window.perms, PERMISSION.UPDATE_BILL)}>
        <Link target="_blank" to={`/bill/edit/${original.id}`}>
          แก้ไข
        </Link>
      </Menu.Item>
      {
        (original.status === status.WAITING || original.status === status.OVERDUE)
        && <Menu.Item key='collect' disabled={!_.includes(window.perms, PERMISSION.RECEIVE_PAYMENT_BILL)}>
        <Link target="_blank" to={`/bill/paid/${original.id}`}>
          เก็บเงิน
        </Link>
        </Menu.Item>
      }
      {
        (original.status === status.WAITING || original.status === status.OVERDUE) && window.role === 'SuperAdmin'
        && <Menu.Item
          style={{ color: theme.color.error }}
          key='cancel'
          disabled={!_.includes(window.perms, PERMISSION.UPDATE_BILL)}
          onClick={() => Modal.confirm({
            title: `คุณต้องการยกเลิกใบปะหน้าเลขที่ ${original.refId}`,
            content: 'ถ้ายกเลิกแล้วจะไม่สามารถแก้ไขได้',
            cancelText: 'เก็บไว้',
            okText: 'ยกเลิกใบปะหน้า',
            onCancel() {
            },
            onOk() {
              doCancel({
                variables: { id: original.id },
              }).then((res) => {
                if (res.data.DeleteBill.success) {
                  message.success(res.data.DeleteBill.message)
                  refetch()
                } else message.error(res.data.DeleteBill.message)
              })
            },
          })}
        >
          ยกเลิก
        </Menu.Item>
      }
    </Menu>
  </Div>
  )
}

export const ActionSelectors = ({ props: { original }, refetch }) => (
  <Div>
    <Dropdown overlay={menu(original, refetch)} trigger='click'>
      <Button>
        ดูรายละเอียด <Icon type="down" />
      </Button>
    </Dropdown>
  </Div>
)

const taxList = [
  { value: 0, text: '0%' },
  { value: 0.5, text: '0.5%' },
  { value: 0.75, text: '0.75%' },
  { value: 1, text: '1%' },
  { value: 2, text: '2%' },
  { value: 3, text: '3%' },
  { value: 5, text: '5%' },
  { value: 10, text: '10%' },
  { value: 11.2, text: '11.2%' },
  { value: 13, text: '13%' },
  { value: 15, text: '15%' },
]

const convertTax = (value) => {
  switch (value) {
    case 0.5: return 'TYPE_05'
    case 0.75: return 'TYPE_075'
    case 1: return 'TYPE_1'
    case 2: return 'TYPE_2'
    case 3: return 'TYPE_3'
    case 5: return 'TYPE_5'
    case 10: return 'TYPE_10'
    case 11.2: return 'TYPE_11_2'
    case 13: return 'TYPE_13'
    case 15: return 'TYPE_15'
    default: return null
  }
}

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const PaymentActionBar = ({
  loading, doAction, mutationVariables, disabled, bill, grandTotal, type,
}) => (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        loading={loading}
        disabled={loading || !_.includes(window.perms, PERMISSION.RECEIVE_PAYMENT_INVOICE) || disabled}
        text='สร้างใหม่'
        icon='fas fa-plus'
        inverse
        onClick={() => {
          doAction({
            variables: {
              ...mutationVariables,
              withHoldingTax: convertTax(mutationVariables.withHoldingTax),
              grandTotal,
              billId: bill.id,
              type,
            },
          }).then(({ data }) => {
            const resp = data.CreateBillPayment
            if (resp.success) {
              message.success(resp.message)
              history.push(`/bill/view/${bill.id}`)
            } else message.error(resp.message)
          })
        }}
      />
    </Div>
)

export const ActionBar = ({
  loading, isAddMode, isViewMode, doAction, mutationVariables, props, invoices, volumeNumber, disabled, bill,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [modal, setModal] = useState(false)
  const thoseWhoCanPrintBill = [3, 4, 5, 6, 7, 10]
  const urlSelector = (group, id, name, fullname) => {
    const token = getAccessToken()
    switch (group) {
      case 3: // cargotype molasse // need modal
        return `render/pdf/type/3.1/${id}?t=${token}`
      case 4:
        return `downloadfile/pdf/scgBill/${id}?t=${token}`
      case 5:
        return `render/pdf/type/5.2/${id}?t=${token}` // along with 5.3
      case 5.3:
        return `render/pdf/type/5.3/${id}?t=${token}`
      case 6:
        return `render/pdf/type/6.1/${id}?t=${token}` // along with 6.2
      case 6.2:
        return `render/pdf/type/6.2/${id}?t=${token}`
      case 7: // need modal
        return `render/pdf/type/7.1/${id}?t=${token}` // cargotype sugar
      case 10: // need modal
        return `render/pdf/type/10.1/${id}?name=${name}&fullname=${fullname}&t=${token}`
      default:
        return null
    }
  }
  const download = (group, id, name, fullname) => {
    setIsLoading(true)
    const url = `${getURL().FILE_SERVER}/${urlSelector(group, id, name, fullname)}`
    window.open(
      url,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoading(false)
  }
  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <KonsysButton
        disabled={_.isEmpty(invoices) || isAddMode || !_.includes(thoseWhoCanPrintBill, bill.Job.Customer.groupId) || (!_.includes([3, 7, 10], bill.Job.Customer.groupId) && isLoading)}
        margin='0 16px'
        text='พิมพ์ใบปะหน้า'
        icon='fas fa-print'
        onClick={() => {
          if (bill.Job.Customer.groupId === 5) {
            download(bill.Job.Customer.groupId, props.match.params.id)
            download(5.3, props.match.params.id)
          } else if (bill.Job.Customer.groupId === 6) {
            download(bill.Job.Customer.groupId, props.match.params.id)
            download(6.2, props.match.params.id)
          } else if (bill.Job.Customer.groupId === 4) {
            download(bill.Job.Customer.groupId, props.match.params.id)
          } else {
            setModal(true)
          }
        }}
        loading={!_.isUndefined(bill) && (!_.includes([3, 7, 10], bill.Job.Customer.groupId) && isLoading)}
      />
      <KonsysButton
        loading={loading}
        disabled={loading || (isViewMode && !_.includes(window.perms, PERMISSION.UPDATE_BILL)) || disabled}
        text={isAddMode ? 'สร้างใหม่' : isViewMode ? 'แก้ไข' : 'บันทึก'}
        icon={isAddMode ? 'fas fa-plus' : isViewMode ? 'fas fa-edit' : 'fas fa-save'}
        inverse
        onClick={() => {
          if (isViewMode) history.push(`/bill/edit/${props.match.params.id}`)
          else {
            doAction({
              variables: isAddMode ? { ...mutationVariables } : { id: parseInt(props.match.params.id, 10), ...mutationVariables },
            }).then(({ data }) => {
              const resp = isAddMode ? data.CreateBill : data.UpdateBill

              if (resp.success) {
                message.success(resp.message)
                if (isAddMode) history.push('/bill')
                // else history.push(`/bill/view/${props.match.params.id}`)
              } else message.error(resp.message)
            })
          }
        }}
      />
      <BillPrintModal
        props={props}
        isLoading={isLoading}
        download={download}
        modal={modal}
        setModal={setModal}
        groupId={!_.isUndefined(bill) && bill.Job.Customer.groupId}
      />
    </Div>
  )
}

export const BillPrintModal = ({
  props, isLoading, download, modal, setModal, groupId,
}) => {
  const [sugarMolasse, setSugarMolasse] = useState(1) // sugar = 1, molasse = 2
  const [name, setName] = useState()
  const [surname, setSurname] = useState()
  return (
    <Modal
      title="เลือกรูปแบบใบปะหน้า"
      visible={modal}
      onCancel={() => {
        setSugarMolasse(1)
        setName()
        setSurname()
        setModal(false)
      }}
      onOk={() => {
        if ((groupId === 3 || groupId === 7) && sugarMolasse === 1) {
          download(7, props.match.params.id)
        } else if ((groupId === 3 || groupId === 7) && sugarMolasse === 2) {
          download(3, props.match.params.id)
        } else if (groupId === 10) {
          download(groupId, props.match.params.id, name, `${name} ${surname}`)
        } else {
          download(groupId, props.match.params.id)
        }
      }}
      okButtonProps={{
        loading: isLoading,
        disabled: isLoading || (groupId === 10 && (_.isUndefined(name) || _.isEmpty(name) || _.isUndefined(surname) || _.isEmpty(surname))),
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
    >
      {
        groupId === 10
          ? <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
              <Div display='flex' flexDirection='row' width='80%' justifyContent='space-between' margin='0 0 8px'>
                <P margin='0 0 8px'>ชื่อ</P>
                <Input width='100%' value={name} onChange={e => setName(e.target.value)}/>
              </Div>
              <Div display='flex' flexDirection='row' width='80%' justifyContent='space-between'>
                <P margin='0 0 8px'>นามสกุล</P>
                <Input width='100%' value={surname} onChange={e => setSurname(e.target.value)}/>
              </Div>
            </Div>
          : <Div display='flex' flexDirection='column' alignItems='center' margin='16px 0 0'>
          <Radio.Group value={sugarMolasse} size="large" onChange={e => setSugarMolasse(e.target.value)}>
            <Radio.Button value={1}>น้ำตาล</Radio.Button>
            <Radio.Button value={2}>โมลาส</Radio.Button>
          </Radio.Group>
        </Div>
      }
    </Modal>
  )
}

export const PaidInfo = ({
  billData, isViewMode, onChangeHandler, mutationVariables, setMutationVariables, data,
}) => {
  const isCheque = billData.payment.type === 'CHEQUE'

  return (
    <Div display='flex' flexDirection='column'>
      <H4 bold margin='24px 0 0'>รายละเอียดการชำระเงิน</H4>
      <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-start' padding='32px 0 24px 0'>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ธนาคาร</P>
          {
            isViewMode
              ? <P>{billData.payment.bank}</P>
              // : <Input defaultValue={billData.payment.bank} onChange={e => onChangeHandler('bank', e.target.value)}/>
              : <Select
                  dropdown
                  showSearch
                  defaultValue={billData.payment.bank}
                  style={{ width: '72%' }}
                  onChange={e => onChangeHandler('bank', e)}
                >
                  {
                    bankList.map(v => !_.isNull(v.text) && <Select.Option key={v.text} value={v.text}>{v.text}</Select.Option>)
                  }
                </Select>
          }
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>{isCheque ? 'หมายเลขเช็ค' : 'หมายเลขธนาคาร'}</P>
          {
            isViewMode
              ? <P>
                {
                  isCheque
                    ? billData.payment.chequeNumber
                    : billData.payment.bankNumber
                }
                </P>
              : <Input
                  defaultValue={
                    isCheque
                      ? billData.payment.chequeNumber
                      : billData.payment.bankNumber
                  }
                  width='72%'
                  onChange={e => onChangeHandler(isCheque ? 'chequeNumber' : 'bankNumber', e.target.value)}
                />
          }
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>วันที่รับชำระ</P>
          {
            isViewMode
              ? <P>{moment(billData.paidDate).format('DD-MM-YYYY')}</P>
              : <DatePicker defaultValue={moment(billData.paidDate)} style={{ width: '72%' }} onChange={e => onChangeHandler('paidDate', moment(e).format())}/>
          }
        </Div>
        {
          (isCheque)
          && <Div display='flex' flexDirection='column' width='20%'>
            <P margin='0 0 16px'>วันที่หน้าเช็ค</P>
            {
              isViewMode
                ? <P>{moment(billData.payment.chequeDate).format('DD-MM-YYYY')}</P>
                : <DatePicker defaultValue={moment(billData.payment.chequeDate)} style={{ width: '72%' }} onChange={e => onChangeHandler('chequeDate', moment(e).format())}/>
            }
          </Div>
        }
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>จำนวนเงิน</P>
          <P>{billData.payment.grandTotal} บาท</P>
        </Div>
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-start' padding='0 0 24px 0'>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>หัก ณ ที่จ่าย</P>
          {
            isViewMode
              ? <P>{_.isNull(billData.payment.withHoldingTax) ? 0 : billData.payment.withHoldingTax} %</P>
              : <Div>
                  <Select
                    defaultValue={_.isNull(billData.payment.withHoldingTax) ? 0 : billData.payment.withHoldingTax}
                    style={{ width: '72%', margin: '0 8px 0 0' }}
                    onChange={(e) => {
                      const newAmountWithHeld = billData.payment.grandTotal * (parseFloat(e) / 100)
                      setMutationVariables({
                        createdDate: data.BillInfo.createdDate,
                        dueDate: data.BillInfo.dueDate,
                        ...mutationVariables,
                        withHoldingTax: convertTax(e),
                        amountWithHeld: newAmountWithHeld,
                        amountReceived: billData.payment.grandTotal - newAmountWithHeld - (_.isUndefined(mutationVariables.customerBankFees) ? billData.payment.customerBankFees : mutationVariables.customerBankFees),
                      })
                    }}
                  >
                  {
                    taxList.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
                  }
                  </Select>
                </Div>
          }
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ยอดเงินหัก ณ ที่จ่าย</P>
          {
            isViewMode
              ? <P>{billData.payment.amountWithHeld.toFixed(2)} บาท</P>
              : <Div>
                  <Input
                    disabled={true}
                    margin='0 8px 0 0'
                    width='72%'
                    value={_.isUndefined(mutationVariables.amountWithHeld) ? billData.payment.amountWithHeld.toFixed(2) : mutationVariables.amountWithHeld.toFixed(2)}
                  />
                </Div>
          }
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ค่าธรรมเนียมที่ลูกค้าจ่าย</P>
          {
            isViewMode
              ? <P>{billData.payment.customerBankFees} บาท</P>
              : <Div display='flex' flexDirection='row'>
                  <Input
                    margin='0 8px 0 0'
                    value={_.isUndefined(mutationVariables.customerBankFees) ? billData.payment.customerBankFees : mutationVariables.customerBankFees}
                    onChange={(e) => {
                      setMutationVariables({
                        createdDate: data.BillInfo.createdDate,
                        dueDate: data.BillInfo.dueDate,
                        ...mutationVariables,
                        customerBankFees: _.isNaN(parseFloat(e.target.value)) ? parseFloat(0) : parseFloat(e.target.value),
                        amountReceived: billData.payment.grandTotal - (_.isUndefined(mutationVariables.amountWithHeld) ? billData.payment.amountWithHeld : mutationVariables.amountWithHeld) - e.target.value,
                      })
                    }}
                    onKeyDown={(e) => {
                      if (!checkFloat(e)) e.preventDefault()
                    }}
                    type='number'
                    step={0.1}
                    min={0}
                    width='72%'
                  />
                </Div>
          }
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ค่าธรรมเนียมที่ผดุงฤทธิ์จ่าย</P>
          <P>{billData.payment.pdrBankFees || 0} บาท</P>
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ส่วนลดน้ำหนักขาด</P>
          <P>{billData.payment.lostWeightFee} บาท</P>
        </Div>
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-start' padding='0 0 24px 0'>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ค่าปรับส่งตั๋วล่าช้า</P>
          <P>{billData.payment.lateTicketFee} บาท</P>
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ค่าสินค้าชำรุดเสียหาย</P>
          <P>{billData.payment.damagedGoodFee} บาท</P>
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ค่าส่วนลดรับ</P>
          <P>{billData.payment.discountFee} บาท</P>
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ค่าส่วนเกิน/ส่วนขาดจากการชำระหนี้</P>
          <P>{billData.payment.excessPaymentFee} บาท</P>
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>ค่าเสียหายจากอุบัติเหตุ</P>
          <P>{billData.payment.accidentFee} บาท</P>
        </Div>
      </Div>
      <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-start' padding='0 0 40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
        <Div display='flex' flexDirection='column' width='20%'>
          <P margin='0 0 16px'>เงินจ่ายล่วงหน้า - เงินประกัน</P>
          <P>{billData.payment.lostInsuranceFee} บาท</P>
        </Div>
        <Div display='flex' flexDirection='column' width='20%'>
          <P bold margin='0 0 16px'>ยอดสุทธิ</P>
          {
            isViewMode
              ? <P bold>{billData.payment.amountReceived.toFixed(2)} บาท</P>
              : <Div>
                  <Input
                    disabled={true}
                    margin='0 8px 0 0'
                    width='72%'
                    value={_.isUndefined(mutationVariables.amountReceived) ? billData.payment.amountReceived.toFixed(2) : mutationVariables.amountReceived.toFixed(2)}
                  />
                </Div>
          }
        </Div>
      </Div>
    </Div>
  )
}
